import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent { }



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/containers/full-layout/full-layout.component.ts